export default __webpack_public_path__ + "static/media/video.16410759.mp4";